import React, { forwardRef, useRef, useState, useImperativeHandle } from 'react'
import { Background, Flex, Card, Icon, Button, Input, TextareaAuto, Hover, Text } from '@Common/Components'
import { getHost, getUrlParams, translateWeekDays, months } from '@Common/Services'
import StepWizard from 'react-step-wizard'
import { Nav } from './Nav'
import moment from 'moment'
import { DayPickerRangeController } from 'react-dates'
import { Checkbox } from 'primereact/checkbox'
import calendar1 from './Calendar1.jpeg'
import calendar2 from './Calendar2.png'
import endWizardImage from './EndWizard.png'
import { handleAppointmentSubmit } from './Functions.js'
import { useMount } from 'react-use'

const images = { calendar1, calendar2 }

const gray = 'rgba(90, 90, 90, 0.85)'

export const PageContent = ({ children, noCard, customBackgroundUrl }) => (
  <Background theme={getHost()[0].theme} customBackgroundUrl={customBackgroundUrl}>
    <Flex fh fw js as style={{ padding: 20, overflowX: 'hidden', overflowY: 'scroll' }}>
      {noCard
        ? <Flex fw row> {children}</Flex>
        : (
          <Card style={{ width: '100%' }}>
            <Flex fw>{children}</Flex>
          </Card>)}
    </Flex>
  </Background>
)

const PhoneMail = ({ icon, text }) => (
  <>
    <Flex fw row wrap style={{ width: '120%' }}>
      <Icon name={icon} style={{ backgroundColor: 'white', borderRadius: 50, width: 50, height: 50, marginBottom: 10, marginRight: 5 }} />
      <Text value={text} style={{ marginBottom: 10, marginLeft: 5 }} color={gray} />
    </Flex>
    <hr style={{ width: '80%', borderColor: 'white', margin: 20 }} />
  </>
)

const days = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica']
const OpeningTime = ({ openSchedule }) =>
  openSchedule?.map((day, index) => (
    <Flex key={index} as js fw row style={{ padding: 5 }}><Text color={gray} value={days[index] + ':'} style={{ width: '40%', marginLeft: -20, paddingLeft: '6%' }} />
      <Flex fw wrap row style={{ marginRight: -40 }}>
        {
          day.map((hours, index) =>
            <Flex row key={index}><Text color={gray} value={hours.from + ' - '} /><Text color={gray} value={hours.to} style={{ marginRight: 5 }} /></Flex>
          )
        }
      </Flex>
    </Flex>))

export const Agency = ({ agency }) => {
  const { openSchedule, logo, name, email, telephone, note } = agency

  return (
    <Card style={{ display: 'flex', textAlign: 'center', justifyContent: 'center', flexDirection: 'column', width: '21%', minWidth: 300, height: '95vh' }}>
      <Flex style={{ margin: 10, height: '100%' }}>
        <img src={logo} style={{ width: '50%' }} alt='logo' />
        <Text center bold size={24} value={name} />
        <Text color={gray} center value={note} style={{ marginTop: 10 }} />
        <hr style={{ width: '80%', borderColor: 'white', margin: 30 }} />
        <PhoneMail icon='mail' text={email} />
        <PhoneMail icon='phone' text={telephone} />
        <Text value='ORARI APERTURA AL PUBBLICO' center bold size={18} />
        <OpeningTime openSchedule={openSchedule} />
      </Flex>
    </Card>
  )
}

const helpLabels = [
  'Clicca per selezionare',
  'Seleziona la modalità di appuntamento',
  'Seleziona la data che preferisci',
  "Seleziona l'orario che preferisci",
  'Inserisci i tuoi dati per inoltrare la richiesta',
  ''
]

export const Wizard = ({
  agency, agencyCode, formData: [formData, setFormData], displayRange: [displayRange, setDisplayRange], range: [range, setRange],
  displayAppointmentType: [displayAppointmentType, setDisplayAppointmentType], appointmentType: [appointmentType, setAppointmentType],
  dateId: [dateId, setDateId], date: [date, setDate], calendarId: [calendarId, setCalendarId], calendar: [calendar, setCalendar],
  displayCalendar: [displayCalendar, setDisplayCalendar], labelNumber: [labelNumber, setLabelNumber], avatar: [avatar, setAvatar]
}) => {
  const values = [displayCalendar, appointmentType, date, range, formData?.name]
  const childRef = useRef(null)
  const [step, setStep] = useState(1)

  const summary = (currentStep, goToStep) =>
    <Summary currentStep={currentStep} goToStep={goToStep} calendar={displayCalendar} date={date} appointmentType={displayAppointmentType} range={displayRange} avatar={avatar} />

  const BottomBar = () =>
    step !== 1 && (
      <Flex as js row style={{ width: '100%', position: 'absolute', left: 0, bottom: 0, backgroundColor: 'white', borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
        <Button rich label='Indietro' styleText={{ color: '#9FD066' }} style={{ border: '3px solid #9FD066', cursor: 'pointer', width: '35%', margin: '2%', marginRight: '26%' }} onClick={() => childRef.current.previousStep()} />
        <Button rich label='Avanti' styleText={{ color: values[step - 1] ? '#9FD066' : 'gainsboro' }} style={{ border: values[step - 1] ? '3px solid #9FD066' : '3px solid gainsboro', cursor: values[step - 1] ? 'pointer' : 'not-allowed', margin: '2%', width: '35%' }} onClick={() => values[step - 1] && childRef.current.nextStep()} />
      </Flex>)

  return (
    <Card style={{ position: 'relative', display: 'flex', textAlign: 'center', flexDirection: 'column', width: '58%', minWidth: 630, marginLeft: 100, height: '95vh' }}>
      <Flex style={{ marginTop: 20, height: '20%' }} js>
        <Text bold size={22} center value='PRENOTA ONLINE UN APPUNTAMENTO CON NOI' />
        <Text style={{ marginTop: 10, marginBottom: 0 }} color={gray} value={helpLabels[labelNumber]} />
      </Flex>
      <Flex style={{ marginTop: 20, paddingBottom: 50, height: '80%' }} js>
        <StepWizard
          nav={<Nav />}
          onStepChange={(({ activeStep }) => {
            setLabelNumber(activeStep - 1)
            setStep(activeStep)
          })}
        >
          <SelectCalendar setAvatar={setAvatar} setCalendarId={setCalendarId} values={values} setDisplayCalendar={setDisplayCalendar} agencyCode={agencyCode} setCalendar={setCalendar} agency={agency} ref={childRef} />
          <AppointmentType setAppointmentType={setAppointmentType} summary={summary} calendarIndex={calendar} agency={agency} setDisplayAppointment={setDisplayAppointmentType} />
          <SelectDate setDateId={setDateId} agency={agency} date={date} setDate={setDate} summary={summary} calendarIndex={calendar} />
          <SelectHour setDisplayRange={setDisplayRange} agency={agency} date={date} setRange={setRange} summary={summary} calendarIndex={calendar} />
          <Form agency={agency} setFormData={setFormData} summary={summary} range={range} formData={formData} appointmentType={appointmentType} date={dateId} calendar={calendarId} />
          <EndWizard summary={summary} />
        </StepWizard>
      </Flex>
      <BottomBar />
    </Card>
  )
}

export const SelectCalendar = forwardRef(({ setCalendarId, setAvatar, values, agencyCode, currentStep, nextStep, setCalendar, agency, previousStep, setDisplayCalendar }, ref) => {
  const { calendars = [] } = agency.appointments || {}
  const cal = getUrlParams('cal')
  useImperativeHandle(ref, () => ({
    previousStep () {
      previousStep()
    },
    nextStep () {
      values[currentStep - 1] && nextStep()
    }
  }))

  useMount(() => {
    if (cal) {
      const foundCal = calendars.find((calendar) => calendar.id.toString() === cal)
      const ind = calendars.findIndex((calendar) => calendar.id.toString() === cal)
      if (foundCal) {
        nextStep()
        setCalendar(ind)
        setCalendarId(foundCal.id)
        setDisplayCalendar(foundCal.name + (foundCal?.service ? (' - ' + foundCal.service) : '') + (foundCal?.operator?.name ? (' - ' + foundCal?.operator?.name + ' ' + foundCal?.operator?.lastName) : ''))
        setAvatar(foundCal?.operator?.avatar)
      }
    }
  })

  return (
    <Flex row wrap style={{ gap: '1em'}}>
      {
        calendars.find(cal => cal.enabled)
          ? calendars.map((cal, ind) => cal.enabled && (
            <Flex 
              key={ind} 
              onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.09)'}
                onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
            >
              <Card
                style={{ 
                  backgroundColor: 'white', 
                  cursor: 'pointer', 
                  height: calendars.length < 3 ? 200 : 180,
                  width: '100%', 
                  minWidth: '250px',
                  border: '2px solid #9FD066', 
                  display: 'flex', 
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  padding: 15,
                  boxSizing: 'border-box',
                  transition: 'transform 0.2s'
                }}
                
                onClick={() => {
                  nextStep()
                  setCalendar(ind)
                  setCalendarId(cal.id)
                  setDisplayCalendar(cal.name + (cal?.service ? (' - ' + cal.service) : '') + (cal?.operator?.name ? (' - ' + cal?.operator?.name + ' ' + cal?.operator?.lastName) : ''))
                  cal?.operator?.avatar && setAvatar(cal.operator.avatar)
                }}
              >
                {cal?.operator?.name && (
                  <Text 
                    style={{ width: '100%', marginBottom: 5 }} 
                    size={18} 
                    center 
                    bold 
                    value={cal?.operator?.name + ' ' + cal?.operator?.lastName} 
                  />
                )}
                <img 
                  src={cal?.operator?.avatar ? ('https://s3.eu-central-1.amazonaws.com/siap.apptour.uploads/' + cal?.operator?.avatar) : images['calendar' + (ind % 2 + 1)]} 
                  style={{ 
                    borderRadius: 20, 
                    width: calendars.length < 3 ? '50%' : '40%',
                    maxHeight: 100,
                    objectFit: 'cover',
                    marginBottom: 10 
                  }} 
                  alt="calendar"
                />
                <Text 
                  center 
                  bold 
                  size={16} 
                  value={(cal?.name || '') + (cal?.service && cal?.name ? ' - ' : '') + (cal?.service || '')} 
                />
              </Card>
            </Flex>
          ))
          : <Card style={{ width: '100%' }}><Text center bold size={18} value='Nessun calendario disponibile' /></Card>
      }
    </Flex>
  )
})

const appointmentTypes = {
  SE: 'Sede',
  OF: 'Ufficio',
  TE: 'Telefono',
  VI: 'Videoconferenza'
}

export const AppointmentType = ({ nextStep, setAppointmentType, currentStep, summary, goToStep, calendarIndex, agency, setDisplayAppointment }) => {
  const { calendars = [] } = agency.appointments || {}
  const calendar = calendars[calendarIndex]
  return (
    <Flex row wrap fw fh>
      {summary(currentStep, goToStep)}
      <Card style={{ backgroundColor: 'white', width: '50%', border: '2px solid #9FD066' }}>
        <Text center bold size={18} value="Come vuoi svolgere l'appuntamento?" />
        <Text center size={16} color='rgba(90, 90, 90, 0.55)' value='Clicca per selezionare la modalità preferita' />
        <Flex row style={{ marginTop: 20}} >
          {calendar?.typeOfAppointment?.length
            ? calendar.typeOfAppointment.map((type, ind) =>
              <Button key={ind} onClick={() => { nextStep(); setAppointmentType(appointmentTypes[type]); setDisplayAppointment(appointmentTypes[type]) }} label={appointmentTypes[type]} styleText={{ color: '#9FD066', fontSize: 14 }} style={{ border: '3px solid #9FD066', width: '48%', marginBottom: 15, marginRight: '1%', marginLeft: '1%' }} />)
            : Object.entries(appointmentTypes).map(([key, value]) =>
              <Button key={key} onClick={() => { nextStep(); setAppointmentType(value); setDisplayAppointment(value) }} label={value} styleText={{ color: '#9FD066', fontSize: 14 }} style={{ border: '3px solid #9FD066', width: '48%', marginBottom: 15, marginRight: '1%', marginLeft: '1%' }} />
            )}
        </Flex>
      </Card>
      <div style={{ flexBasis: '100%' }} />
    </Flex>
  )
}

const getId = (date) => moment(date).diff(moment('2020-06-01'), 'days')

export const SelectDate = ({ agency, nextStep, date, setDate, currentStep, goToStep, summary, calendarIndex, setDateId }) => {
  const { calendars = [] } = agency.appointments || {}

  const calendar = calendars[calendarIndex]

  const isDayBlocked = (day) => !day || !calendar || !calendar.openings || day.isBefore(moment().add(-1, 'day')) || !calendar.openings.find((o) => o.dayId === getId(day))

  return (
    <Flex row fw fh>
      {summary(currentStep, goToStep)}
      {calendar &&
        <Flex style={{ boxShadow: 'rgb(100 100 100 / 24%) 0px 4px 13px 3px', border: '2px solid #9FD066', borderRadius: 20 }}>
          <DayPickerRangeController
            hideKeyboardShortcutsPanel
            startDate={date ? moment(date) : null}
            endDate={null}
            onDatesChange={({ startDate }) => { setDate(startDate); nextStep(); setDateId(getId(startDate)) }}
            focusedInput='startDate'
            isDayHighlighted={(day) => false}
            isDayBlocked={isDayBlocked}
            firstDayOfWeek={1}
            renderMonthElement={({ month }) => <Text center bold size={18} value={`${months?.[month.format('MMMM')]} ${month.format('YYYY')}`} />}
            renderDayContents={translateWeekDays}
          />
        </Flex>}
    </Flex>
  )
}

export const SelectHour = ({ nextStep, agency, date, setRange, summary, currentStep, goToStep, setDisplayRange, calendarIndex }) => {
  const { calendars = [] } = agency.appointments || {}
  const calendar = calendars[calendarIndex]
  const idDate = getId(date)
  const calendarOfTheDay = calendar?.openings?.find((item) => item.dayId === idDate)
  return (
    <Flex row style={{ marginTop: calendarOfTheDay?.timeSlots?.length > 18 ? -30 : 0 }}>
      {summary(currentStep, goToStep)}
      <Card style={{ backgroundColor: 'white', width: '50%', border: '2px solid #9FD066' }}>
        <Text center bold size={18} value='Orario' />
        <Text center size={16} color='rgba(90, 90, 90, 0.55)' value="Seleziona l'ora dell'appuntamento" style={{ marginBottom: 10 }} />
        <Flex wrap row style>
          {calendarOfTheDay?.timeSlots?.map((slot, index) =>
            <Button
              key={index}
              onClick={() => {
                if (slot.state === 'available') {
                  nextStep(); setDisplayRange(slot.fromDisplay + ' - ' + slot.toDisplay); setRange(slot.id)
                }
              }} rich label={slot.fromDisplay} styleText={{ color: slot.state === 'available' ? '#9FD066' : 'gainsboro' }}
              style={{ border: slot.state === 'available' ? '3px solid #9FD066' : '3px solid gainsboro', cursor: slot.state === 'available' ? 'pointer' : 'not-allowed', width: calendarOfTheDay.timeSlots.length > 20 ? '20%' : calendarOfTheDay.timeSlots.length > 15 ? '25%' : '42%', marginBottom: 15, marginRight: '2%', marginLeft: '2%' }}
            />
          )}
        </Flex>
      </Card>
    </Flex>
  )
}

export const Form = ({ setFormData, goToStep, currentStep, summary, nextStep, range, formData, appointmentType, date, calendar, agency }) => {
  const [name, setName] = useState('')
  const [lastName, setLastName] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [email, setEmail] = useState('')
  const [info, setInfo] = useState('')
  const [errorLabel, setErrorLabel] = useState('')
  const [privacyChecked, setPrivacyChecked] = useState(false)

  const dataCheck = () => {
    !email && setErrorLabel("Inserisci l'email")
    !phoneNumber && setErrorLabel('Inserisci il numero di cellulare')
    !lastName && setErrorLabel('Inserisci il cognome')
    !name && setErrorLabel('Inserisci il nome')
    !privacyChecked && setErrorLabel('Devi acconsentire il trattamento dei dati')
    return !!(email && phoneNumber && lastName && name && privacyChecked)
  }

  const handleForm = () => {
    if (dataCheck()) {
      setErrorLabel('')
      handleAppointmentSubmit(
        agency._id, range,
        { name, surname: lastName, phone: phoneNumber, email, ...(info ? { request: info } : {}) },
        appointmentType, date, calendar)
      nextStep()
    }
  }

  return (
    <Flex row style={{ marginTop: -20 }} fw fh>
      {summary(currentStep, goToStep)}
      <Card style={{ backgroundColor: 'white', width: '50%', border: '2px solid #9FD066' }}>
        <Text center bold size={18} value='Inserisci i tuoi dati' />
        <Text center size={16} color='rgba(90, 90, 90, 0.55)' value='Completa la richiesta inderendo i tuoi dati' />
        <Flex wrap row style={{ paddingTop: 10 }}>
          <Input id='name' placeholder='Nome' style={{ width: '95%', marginBottom: 10, backgroundColor: 'rgba(231, 231, 231, 0.8)' }} value={name} onChange={(e) => setName(e.name)} />
          <Input id='lastName' value={lastName} onChange={(e) => setLastName(e.lastName)} placeholder='Cognome' style={{ width: '95%', marginBottom: 10, backgroundColor: 'rgba(231, 231, 231, 0.8)' }} />
          <Input id='phoneNumber' placeholder='Cellulare' value={phoneNumber} onChange={(e) => setPhoneNumber(e.phoneNumber)} style={{ width: '95%', marginBottom: 10, backgroundColor: 'rgba(231, 231, 231, 0.8)' }} />
          <Input id='email' value={email} onChange={(e) => setEmail(e.email)} placeholder='Email' style={{ width: '95%', marginBottom: 10, backgroundColor: 'rgba(231, 231, 231, 0.8)' }} />
          <TextareaAuto id='info' value={info} onChange={(e) => setInfo(e.target.value)} style={{ backgroundColor: 'rgba(231, 231, 231, 0.8)', width: '95%', marginBottom: 10, fontSize: 16 }} placeholder='A cosa sei interessato?' />
          <Text style={{ width: '100%', marginBottom: 0, fontSize: 18 }} color='red' center value={errorLabel} />
          <Flex row fw>
            <Checkbox checked={privacyChecked} onChange={(e) => setPrivacyChecked(!privacyChecked)} />
            <Text value='Acconsento al trattamento dei dati e info privacy' style={{ marginLeft: 5 }} />
          </Flex>
          <Button label='Inoltra richiesta' rich styleText={{ color: '#9FD066' }} style={{ border: '3px solid #9FD066', marginTop: 20 }} onClick={handleForm} />
        </Flex>
      </Card>
    </Flex>
  )
}

export const EndWizard = ({ currentStep, goToStep }) => (
  <Flex style={{ height: '56%', marginTop: -20 }} fw fh>
    <Card style={{ backgroundColor: 'white', width: '80%', height: '90%', display: 'flex', flexDirection: 'column', alignContent: 'center', alignItems: 'center', justifyContent: 'center' }}>
      <Text size={22} bold center value='Grazie per inviato la tua richiesta di appuntamento!' />
      <Text size={18} color={gray} center value="Attendi l'email di conferma, riceverai tutte le istruzioni per poter partecipare all'evento." />
      <img src={endWizardImage} style={{ width: '50%', margin: 20 }} />
      <Button
        style={{ width: '50%', textDecoration: 'underline', backgroundColor: '#9FD066', color: 'white', marginTop: 20, marginLeft: '25%', marginRight: '25%' }}
        styleText={{ color: 'white', margin: 5, width: '100%' }} label='Invia una nuova richiesta' onClick={() => window.location.reload()}
      />
    </Card>
  </Flex>
)

const Summary = ({ currentStep, goToStep, calendar, range, appointmentType, date, avatar }) => (
  <Card style={{ backgroundColor: 'white', width: '45%', marginRight: '5%', border: '2px solid #9FD066' }}>
    <Flex row fw>
      <Flex as style={{ width: '90%', margin: 10 }}>
        <Flex row>
          <div>
            <Text value='Operatore:' bold />
            <Text value={calendar} bold />
          </div>
          {avatar && (
            <img
              src={'https://s3.eu-central-1.amazonaws.com/siap.apptour.uploads/' + avatar}
              style={{ borderRadius: 20, width: 60, marginLeft: 10 }}
            />
          )}
        </Flex>
      </Flex>
      <Button label='Modifica' rich styleText={{ color: '#9FD066' }} onClick={() => goToStep(1)} />
    </Flex>
    {
      currentStep > 2 && (
        <>
          <hr />
          <Flex row fw>
            <Flex as style={{ width: '90%', margin: 10 }}>
              <Text value='Modalità appuntamento:' bold /><Text value={appointmentType} bold />
            </Flex>
            <Button label='Modifica' rich styleText={{ color: '#9FD066' }} onClick={() => goToStep(2)} />
          </Flex>
        </>)
    }
    {
      currentStep > 3 && (
        <>
          <hr />
          <Flex row fw>
            <Flex as style={{ width: '90%', margin: 10 }}>
              <Text value='Giorno appuntamento:' bold /><Text value={date.format('DD/MM/YYYY')} bold />
            </Flex>
            <Button label='Modifica' rich styleText={{ color: '#9FD066' }} onClick={() => goToStep(3)} />
          </Flex>
        </>)
    }
    {
      currentStep > 4 && (
        <>
          <hr />
          <Flex row fw>
            <Flex as style={{ width: '90%', margin: 10 }}>
              <Text value='Ora appuntamento:' bold /><Text value={range} bold />
            </Flex>
            <Button label='Modifica' rich styleText={{ color: '#9FD066' }} onClick={() => goToStep(4)} />
          </Flex>
        </>)
    }
  </Card>
)
